import Column from '@components/Column';
import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import { IconProps } from '@models/icons';
import { pressActionEffect } from '@styles/mixin';
import { JSX } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
    label: string;
    icon: (props: IconProps) => JSX.Element;
    onClick?: () =>void;
}

function SidebarButton({ label, icon: Icon, onClick }:Props) {
    const { i18n } = useTranslation();
    const { language } = i18n;
    return (
        <Container spacing={8}
            align='center'
            onClick={onClick}
            isJa={language === 'ja'} >
            <Icon size={24} color={colors.gray9}/>
            <BreakText color={colors.gray7} fontWeight='medium' align='center'>
                {label}
            </BreakText>
        </Container>
    );
}

const Container = styled(Column)<{
    isJa?: boolean;
}>`
    border: 1px solid ${colors.gray2};
    padding: 16px 8px;
    border-radius: 16px;
    min-height: ${({ isJa }) => (isJa ? '106px' : 'unset')};
    ${pressActionEffect}
`;

const BreakText = styled(Text)`
    word-break: break-word;
`;

export default SidebarButton;
